import { Component, input, output } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { Button } from 'excellence-ui';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-parse-request-created-requirements-dialog',
  templateUrl: './parse-request-created-requirements-dialog.html',
  imports: [NgIcon, Button, TranslocoPipe],
})
export class ParseRequestCreatedRequirementsDialog {
  closeDialog = output();

  organizationId = input.required<string>();
}
